import { IOneGallery } from './Common';
//根据gallery-list.scss的设定，大于450认为是PC级别的，需要将高度*2
const isPcSize = document.documentElement.clientWidth >= 450;

const MODE2_BORDER_BOTTOM = 0;

interface IEnhancedOneGallery extends IOneGallery {
  //offsetImgHeight:number;
  originalIndex: number;
}

export interface IColumn2OffsetHeight {
  height: number;
  index: number;
}

// 单独对list2 做处理
const getHeight = function(flag: boolean) {
  const ratio = flag ? 2 : 1;
  let mobileHeight = ratio * 120;
  isPcSize && (mobileHeight *= 2);
  return mobileHeight + MODE2_BORDER_BOTTOM;
};
const addAll = function(columnList: IColumn2OffsetHeight[]) {
  const addList = [] as IColumn2OffsetHeight[];
  const len = columnList.length;
  let sum = 0;
  for (let i = 0; i < len; i++) {
    const one = columnList[i];
    const { height, index } = one;
    sum += height;
    addList.push({
      height: sum,
      index
    });
  }
  return addList;
};

export default function(list: IOneGallery[]) {
  const column1 = [] as IEnhancedOneGallery[];
  let column1height = 0;
  const column2 = [] as IEnhancedOneGallery[];
  let column2height = 0;

  const column1HeightList = [] as IColumn2OffsetHeight[];
  const column2HeightList = [] as IColumn2OffsetHeight[];
  list.forEach((it, index) => {
    const currentWHRatio = it.width * 1 < it.height * 1;
    const currentImgHeight = getHeight(currentWHRatio);
    const one = {
      ...it,
      originalIndex: index
    };

    if (column1height <= column2height) {
      column1height += currentWHRatio ? 2 : 1;
      column1HeightList.push({
        height: currentImgHeight,
        index
      });
      column1.push(one);
    } else {
      column2height += currentWHRatio ? 2 : 1;
      column2HeightList.push({
        height: currentImgHeight,
        index
      });
      column2.push(one);
    }
  });
  const c1Offset = addAll(column1HeightList);
  const c2Offset = addAll(column2HeightList);

  const cOffset = [...c1Offset, ...c2Offset].sort(function(pre, next) {
    const preH = pre.height;
    const nextH = next.height;
    // 相同高度时，后者排在前面
    if (preH === nextH) {
      return next.index - pre.index;
    }
    return preH - nextH;
  });

  return {
    column1,
    column2,
    cOffset,
    c1Offset
  };
}
